import {LayoutConfigModel} from '../_base/layout';

export class LayoutConfig {
	public defaults: LayoutConfigModel = {
		demo: 'demo1',
		js: {
			breakpoints: {
			  sm: 576,
			  md: 768,
			  lg: 992,
			  xl: 1200,
			  xxl: 1200,
			},
			colors: {
			  theme: {
				base: {
				  white: '#ffffff',
				  primary: '#6993FF',
				  secondary: '#E5EAEE',
				  success: '#1BC5BD',
				  info: '#8950FC',
				  warning: '#FFA800',
				  danger: '#F64E60',
				  light: '#F3F6F9',
				  dark: '#212121',
				},
				light: {
				  white: '#ffffff',
				  primary: '#E1E9FF',
				  secondary: '#ECF0F3',
				  success: '#C9F7F5',
				  info: '#EEE5FF',
				  warning: '#FFF4DE',
				  danger: '#FFE2E5',
				  light: '#F3F6F9',
				  dark: '#D6D6E0',
				},
				inverse: {
				  white: '#ffffff',
				  primary: '#ffffff',
				  secondary: '#212121',
				  success: '#ffffff',
				  info: '#ffffff',
				  warning: '#ffffff',
				  danger: '#ffffff',
				  light: '#464E5F',
				  dark: '#ffffff',
				},
			  },
			  gray: {
				gray100: '#F3F6F9',
				gray200: '#ECF0F3',
				gray300: '#E5EAEE',
				gray400: '#D6D6E0',
				gray500: '#B5B5C3',
				gray600: '#80808F',
				gray700: '#464E5F',
				gray800: '#1B283F',
				gray900: '#212121',
			  },
			},
			fontFamily: 'Poppins',
		  },
		// == Base Layout
		self: {
			layout: 'fluid', // fluid|boxed
			body: {
				'background-image': './assets/media/misc/bg-1.jpg',
			},
			logo: {
				dark: './assets/media/rep-logo/horizontal-white.png',
				light: './assets/media/rep-logo/horizontal-white.png',
				brand: './assets/media/rep-logo/horizontal-white.png',
				green: './assets/media/rep-logo/horizontal-white.png',
			},
		},
		// == Page Splash Screen loading
		loader: {
			enabled: true,
			type: 'spinner-logo',
			logo: './assets/media/rep-logo/loading-image.png',
			message: 'Please wait...',
		},
		// == Colors for javascript
		colors: {
			state: {
				brand: '#5d78ff',
				dark: '#282a3c',
				light: '#ffffff',
				primary: '#5867dd',
				success: '#34bfa3',
				info: '#36a3f7',
				warning: '#ffb822',
				danger: '#fd3995',
			},
			base: {
				label: [
					'#c5cbe3',
					'#a1a8c3',
					'#3d4465',
					'#3e4466',
				],
				shape: [
					'#f0f3ff',
					'#d9dffa',
					'#afb4d4',
					'#646c9a',
				],
			},
		},
		header: {
			self: {
				skin: 'light',
				fixed: {
					desktop: true,
					mobile: true,
				},
			},
			menu: {
				self: {
					display: true,
					layout: 'default',
					'root-arrow': false,
				},
				desktop: {
					arrow: true,
					toggle: 'click',
					submenu: {
						skin: 'light',
						arrow: true,
					},
				},
				mobile: {
					submenu: {
						skin: 'dark',
						accordion: true,
					},
				},
			},
		},
		subheader: {
			display: true,
			layout: 'subheader-v1',
			fixed: true,
			width: 'fluid',
			style: 'solid',
		},
		content: {
			width: 'fluid',
		},
		brand: {
			self: {
				skin: 'dark',
			},
		},
		aside: {
			self: {
				skin: 'dark',
				display: true,
				fixed: true,
				minimize: {
					toggle: true,
					default: true,
				},
			},
			footer: {
				self: {
					display: true,
				},
			},
			menu: {
				dropdown: false,
				scroll: false,
				submenu: {
					accordion: true,
					dropdown: {
						arrow: true,
						'hover-timeout': 500,
					},
				},
			},
		},
		footer: {
			self: {
				width: 'fluid',
			},
		},
	};

	/**
	 * Good place for getting the remote config
	 */
	public get configs(): LayoutConfigModel {
		// console.log(this.defaults);
		return this.defaults;
	}
}
